/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: INOX A/S
 Date of creation: 21st December 2015
 */


(function ($, dis) {
    "use strict";

    dis.Selector = function (objectConfiguration) {
        dis.BaseModule.call(this);

        var defaults = {
                activeClass: 'selector--active',
                visibleClass: 'selector--visible'
            },
            configuration = $.extend(true, defaults, objectConfiguration),
            dom = {},
            selfScope = this;



        function buildSelected(element) {
            var option = $(element),
                choice = $('<li />', {
                    'class': 'selector__selected__option'
                }).attr('data-selector-id', option.attr('data-selector-id')).appendTo(dom.selectorSelected),
				choiceInside = $('<div />', {
					'class': 'selector__selected__option__inside',
					'text': option.text()
				}).appendTo(choice);

            $('<div />', {
                'class': 'selector__selected__remove',
                'html': configuration.removeIcon
            }).appendTo(choiceInside).click(function () {
                var selectorId = option.attr('data-selector-id'),
                    selectboxOption = dom.selectBoxOptions.filter('[data-selector-id=' + selectorId + ']');

                selectboxOption.prop('selected', false).change();
                dom.selectBox.change();
            });
        }


        this.eventHandlers = {
            toggleActive: function (set) {
                // Function for showing and hiding the dropdown box
                //--------------------------------------------------

                var openselector = (typeof set === 'string' ? (set === 'open' ? 1 : 0) : !dom.container.hasClass(configuration.activeClass));

                if (openselector) {
                    // Open selector
                    //---------------

                    // Close other open selector (if any)
                    dis.BaseModule.prototype.globalDOM.body.trigger('dis.selector.close');

                    // Close when clicking outside the selector
                    dis.BaseModule.prototype.globalDOM.body.on('click', selfScope.eventHandlers.toggleActive);

                    // Close when another selector is activated
                    dis.BaseModule.prototype.globalDOM.body.on('dis.selector.close', selfScope.eventHandlers.closeActive);

                    // Add classes to container to open selector
                    dom.container.addClass(configuration.activeClass);
                    dom.container.hide().show(0); // Redraw
                    dom.container.addClass(configuration.visibleClass);
                } else {
                    // Close selector
                    //----------------

                    // Stop listening for clicks outside the selector
                    dis.BaseModule.prototype.globalDOM.body.off('click', selfScope.eventHandlers.toggleActive);

                    // Stop listening for  other selectors opening
                    dis.BaseModule.prototype.globalDOM.body.off('dis.selector.close', selfScope.eventHandlers.closeActive);

                    // Remove classes from container to close selector
                    dom.container.removeClass(configuration.activeClass);
                    dom.container.removeClass(configuration.visibleClass);
                }
            },
            closeActive: function () {
                selfScope.eventHandlers.toggleActive(false);
            },
            toggleOption: function (clickedId, setState) {
                // Function for toggling the state of an option (only the generated frontend, not the <select>
                //---------------------------------------------------------------------------------------------

                var origin = dom.selectBoxOptions.filter('[data-selector-id=' + clickedId + ']'),
                    option = dom.selectorOptions.find('[data-selector-id=' + clickedId + '] input'),
                    newTitle;

                setState = (typeof setState === "undefined" ? !origin.is(':selected') : setState);

                if (setState) {
                    origin.prop('selected', true);
                    option.prop('checked', true);

                    if (configuration.multiple) {
                        // If it's possible to select multiple options, build a list of selected options
                        buildSelected(origin);
                    } else {
                        // If only one selection is possible at a time, select this
                        newTitle = origin.data('title') || origin.text() || dom.selectBox.data('title');
                        dom.selectorTitle.html(newTitle);
                    }
                } else {
                    origin.prop('selected', false);
                    option.prop('checked', false);

                    if (configuration.multiple) {
                        // If it's possible to select multiple options, remove this from the list of selected options
                        dom.selectorSelected.find('[data-selector-id=' + clickedId + ']').remove();
                    }
                }
            },
            // Add keyboard navigation.
            keyNavigation: function (event) {
                event.stopImmediatePropagation();
                var options = $('.selector__options', $(event.currentTarget).parent());
                switch (event.which) {
                    case 13: {
                       selfScope.eventHandlers.toggleActive();
                    } break;
                    case 40: {
                        options.children().first().focus();
                    } break;
                    case 27: {
                        selfScope.eventHandlers.toggleActive(false);
                    }
                }

                $('.selector__option', options).off('focus').on('focus', function (event) {
                    event.stopImmediatePropagation();
                    var target = event.currentTarget;
                    $(target).off('keydown').on('keydown', function (event) {
                        event.preventDefault();

                        switch (event.which) {
                            // Enter
                            case 13: {
                                $('label', target).click();
                            } break;
                            // Down arrow
                            case 40: {
                                if (target.nextElementSibling) {
                                    target.nextSibling.focus();
                                } else {
                                    target.parentElement.firstChild.focus();
                                }

                            } break;
                            // Up arrow
                            case 38: {
                                if (target.previousElementSibling) {
                                    target.previousSibling.focus();
                                } else {
                                    target.parentElement.lastChild.focus();
                                }
                            } break;
                            // Escape
                            case 27: {
                                selfScope.eventHandlers.toggleActive();
                            } break;
                        }
                    });
                });
            },
            reset: function () {
                // Loop through selected options and reset them
                //----------------------------------------------

                dom.selectorSelected.find('li').each(function () {
                    var selectorId = $(this).data('selector-id'),
                        selectboxOption = dom.selectBoxOptions.filter('[data-selector-id=' + selectorId + ']');

                    selectboxOption.prop('selected', false).change();
                    dom.selectBox.change();
                });
            },
			rebuild: function () {
				dom.selectorSelected.empty();
				dom.selectBoxOptions.each(function () {
					var option = $(this),
						selectorId = option.attr('data-selector-id');

					if (option.is(':selected')) {
						// Make sure this selected option is showing in frontend
						selfScope.eventHandlers.toggleOption(selectorId, true);
					} else {
						// Make sure this unselected option is not showing in frontend
						selfScope.eventHandlers.toggleOption(selectorId, false);
					}
				});
			}
        };


        function init() {
            dom.selectBox = $(configuration.selector);

            if (dom.selectBox.length && !dom.selectBox.hasClass('selector--ready')) {
                var idSuffix = Math.floor((Math.random() * 42) + 48) + Date.now().toString().substr(-3);

                // Cache select box
                dom.selectBoxOptions = dom.selectBox.find('option');

                // Where to place selected options
                dom.selectedWrapper = configuration.selectedWrapper ? $(configuration.selectedWrapper) : dom.container;

                // Build selector
                //----------------
                configuration.title = dom.selectBox.data('title') || dom.selectBoxOptions.first().text();
                configuration.multiple = dom.selectBox.is('[multiple]');
                configuration.triggerIcon = dom.selectBox.data('trigger-icon');
                configuration.removeIcon = dom.selectBox.data('remove-icon');


                dom.selectBox.removeClass('selector');
                dom.container = $('<div />', {
                    'class': 'selector'
                }).insertBefore(dom.selectBox);

                if (configuration.multiple) {
                    dom.container.addClass('selector--multiple');
                } else {
                    dom.container.addClass('selector--single');
                }

                dom.selectorTop = $('<div />', {
                    'class': 'selector__top'
                }).prependTo(dom.container);

                dom.selectorTrigger = $('<div />', {
                    'class': 'selector__trigger',
                    'tabindex': 0
                }).appendTo(dom.selectorTop).click(function (event) {
                    event.stopPropagation();

                    // Open clicked selector
                    selfScope.eventHandlers.toggleActive();
                }).focus(function() {
                    $(this).keydown(function (event) {
                        selfScope.eventHandlers.keyNavigation(event);
                    });
                });

                dom.selectorTitle = $('<div />', {
                    'class': 'selector__title',
                    'text': configuration.title
                }).appendTo(dom.selectorTrigger);

				// dom.selectBox.setAttribute('aria-label', 'heading' + configuration.title);

                dom.selectorTriggerIcon = $('<div />', {
                    'class': 'selector__trigger__icon',
                    'html': configuration.triggerIcon
                }).appendTo(dom.selectorTrigger);

                dom.selectBox.appendTo(dom.selectorTop);

                dom.selectorOptions = $('<ul />', {
                    'class': 'selector__options'
                }).appendTo(dom.selectorTop);

                // Build options
                //---------------
                dom.selectBoxOptions.each(function (index) {
                    var origin = $(this),
                        originText = origin.text(),
                        selectorId = 'selector_' + index + '_' + originText.replace(/[^a-z0-9]/gi, '_') + '_' + idSuffix,
                        option;

                    option = $('<li />', {
                        'class': 'selector__option',
                        'tabindex': 0
                    }).appendTo(dom.selectorOptions).click(function (event) {
                        event.stopPropagation();
                    });

                    if (configuration.multiple) {
                        $('<input>', {
                            'type': 'checkbox',
                            'id': selectorId,
                            'checked': origin.is('[selected]'),
                            'disabled': origin.is('[disabled]')
                        }).appendTo(option).change(function () {
                            var thisSelectorId = option.attr('data-selector-id'),
                                selectBoxOption = dom.selectBoxOptions.filter('[data-selector-id="' + thisSelectorId + '"]');

                            selectBoxOption.prop('selected', !selectBoxOption.prop('selected'));
                            dom.selectBox.change();
                        });

                        $('<label>', {
                            'text': originText,
                            'for': selectorId
                        }).appendTo(option);
                    } else {
                        $('<input>', {
                            'type': 'radio',
                            'id': selectorId,
                            'name': 'selector_radio_' + idSuffix,
                            'checked': origin.is('[selected]'),
                            'disabled': origin.is('[disabled]')
                        }).appendTo(option).change(function () {
                            var thisSelectorId = option.attr('data-selector-id'),
                                selectBoxOption = dom.selectBoxOptions.filter('[data-selector-id="' + thisSelectorId + '"]');

                            selectBoxOption.prop('selected', !selectBoxOption.prop('selected'));
                            dom.selectBox.change();
                        }).click(function () {
                            // Close selector on click
                            selfScope.eventHandlers.toggleActive(false);
                        });

                        $('<label>', {
                            'text': originText,
                            'for': selectorId
                        }).appendTo(option);
                    }

                    origin.attr('data-selector-id', selectorId);
                    option.attr('data-selector-id', selectorId);
                });

                dom.selectorSelected = $('<ul />', {
                    'class': 'selector__selected'
                }).appendTo(dom.selectedWrapper);

                dom.selectBoxOptions.filter('[selected]').each(function () {
                    buildSelected(this);
                });

                dom.container.addClass('selector--ready');

                // Listen for changes on the original <select>
                //---------------------------------------------
                dom.selectBox.change(selfScope.eventHandlers.rebuild);
            }
        }

        selfScope.onReady(init);
    };

    dis.Selector.prototype = new dis.BaseModule();
    dis.Selector.constructor = dis.Selector;

}(jQuery, dis));
